export const ADSENSE_CLIENT = 'ca-pub-2140697240492078';

/** Display units from the AdSense dashboard. */
export const AD_SLOTS = {
  gameFooter: '5564131483', // Ad1
  howToPlay: '3481531657', // Ad2
};

export function isLocalHost(hostname = window.location.hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}
